const AppConfigs = {
  WEB_APP_URL: "https://dev.dilly-ai.com",
  PRIVACY_POLICY: "https://example.com/privacy-policy/",
  TERMS_OF_SERVICE: "https://example.com/terms-of-use/",
};

export default AppConfigs;
